import { Modal } from "../components/ui/modal";
export default Modal;